import * as React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { useState, useEffect } from "react";
import { useFetch } from "../hooks/useFetch";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useDispatch, useSelector } from "react-redux";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { registrationActions } from "../store/registrationSlice";
import "./Booking.css";
import { useBeforeunload } from "react-beforeunload";

const locations = [
  { id: 1, location: "Marina Square" },
  { id: 2, location: "West Coast Plaza" },
];

export default function Booking() {
  const dispatch = useDispatch();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [contact, setContact] = useState("");
  const [email, setEmail] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [isValidContact, setIsValidContact] = useState(true);
  const [date, setDate] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [timeslot, setTimeslot] = useState("");
  const [location, setLocation] = useState("Marina Square");

  const bookingDetails = useSelector(
    (state) => state.registration.bookingDetails
  );

  const { data, isPending, error } = useFetch(
    `https://cuddly-purple-settee.glitch.me/api/dates/${location}`
  );

  // Populate the states with data from redux store
  useEffect(() => {
    if (bookingDetails) {
      setFirstName(bookingDetails.firstName);
      setLastName(bookingDetails.lastName);
      setContact(bookingDetails.contact);
      setEmail(bookingDetails.email);
    }
  }, [bookingDetails]);

  const [filteredDates, setFilteredDates] = useState([]);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [product, setProduct] = useState("");

  const validateEmail = () => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    } else {
      return false;
    }
  };

  // Function to validate phone number
  const validatePhone = () => {
    if (/^\d+$/.test(contact)) {
      return true;
    } else {
      return false;
    }
  };

  const DATE_FORMAT = "MM/DD/YYYY";
  const filterDates = (val) => {
    const filteredDates = data.filter(
      (d) => moment(d.Date).format(DATE_FORMAT) === val.format(DATE_FORMAT)
    );
    setDate(val);
    setFilteredDates(filteredDates);
  };

  const filterTickets = (val) => {
    const filteredTimeslots = filteredDates.filter((d) => d.Timeslot === val);
    setTimeslot(val);
    setProduct(filteredTimeslots[0]);

    const filteredTickets = Array.from(
      { length: filteredTimeslots[0].Tickets },
      (_, i) => i + 1
    ).map((val, index) => ({
      label: val,
      value: val,
    }));
    setFilteredTickets(filteredTickets);
  };

  const handleNext = async () => {
    // e.preventDefault();
    // console.log(date.day());

    if (validateEmail() && validatePhone()) {
      const bookingDetails = {
        firstName,
        lastName,
        contact,
        email,
        location,
        date: moment(date).format("YYYY-MM-DD"),
        quantity,
        timeslot,
        product,
        promoCode: "no promo code",
        isOrganic: true,
      };
      dispatch(registrationActions.setBookingDetails(bookingDetails));
    } else if (!validateEmail()) {
      setIsValidEmail(false);
      alert("Invalid email");
    } else if (!validatePhone()) {
      setIsValidContact(false);
      alert("Invalid phone number");
    }
  };

  return (
    <>
      <form>
        <Typography variant="h6" gutterBottom>
          Particulars
        </Typography>
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="firstName"
              name="firstName"
              label="First name"
              autoComplete="given-name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="lastName"
              name="lastName"
              label="Last name"
              autoComplete="family-name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              error={!isValidContact}
              id="contact"
              name="contact"
              label="Contact"
              autoComplete="contact"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              error={!isValidEmail}
              required
              id="emailAddress"
              name="emailAddress"
              label="Email"
              autoComplete="email address-line"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Grid>
        </Grid>
        <Typography variant="h6" gutterBottom>
          Location
        </Typography>
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12} sm={6}>
            <FormControl>
              <InputLabel>Outlet</InputLabel>
              <Select
                sx={{ width: 200 }}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={location}
                label="Location"
                required
                onChange={(e) => setLocation(e.target.value)}
              >
                {locations.map((l) => (
                  <MenuItem key={l.id} value={l.location}>
                    {l.location}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        {error && <p className="error">{error}</p>}
        {isPending && <p className="loading">Loading...</p>}
        {data && !isPending && (
          <div>
            <Typography variant="h6" gutterBottom>
              Timeslot
            </Typography>
            <Grid container spacing={3} sx={{ mb: 4 }}>
              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    className="input-field"
                    label="Date"
                    value={date}
                    onChange={(date) => {
                      // setDate(date);
                      filterDates(date);
                    }}
                    minDate={moment()}
                    //TODO: Change to 30 days
                    maxDate={moment().add(7, "days")}
                    required
                    renderInput={(params) => <TextField {...params} />}
                    // renderDay={(day, _value, DayComponentProps) => {
                    //   return (
                    //     <div className="date_obj">
                    //       <p>1</p>
                    //       <PickersDay {...DayComponentProps} />
                    //     </div>
                    //   );
                    // }}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12} sm={6}>
                {date && (
                  <FormControl>
                    <InputLabel>Time</InputLabel>
                    <Select
                      sx={{ width: 150 }}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={timeslot}
                      label="Time"
                      required
                      onChange={(e) => filterTickets(e.target.value)}
                    >
                      {filteredDates.map(
                        (d) =>
                          d.Tickets > 0 && (
                            <MenuItem key={d.ID} value={d.Timeslot}>
                              {d.Timeslot}
                            </MenuItem>
                          )
                      )}
                    </Select>
                  </FormControl>
                )}
              </Grid>
            </Grid>

            {timeslot && (
              <>
                <Typography variant="h6" gutterBottom>
                  Tickets
                </Typography>

                <FormControl>
                  <InputLabel>Qty</InputLabel>
                  <Select
                    sx={{ width: 100 }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={quantity}
                    label="Qty"
                    required
                    onChange={(e) => setQuantity(e.target.value)}
                  >
                    {filteredTickets.map((t) => (
                      <MenuItem key={t.value} value={t.value}>
                        {t.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </>
            )}
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                disabled={timeslot ? false : true}
                // type="submit"
                variant="contained"
                onClick={handleNext}
                sx={{ mt: 3, ml: 1 }}
                value="submit"
              >
                Next
              </Button>
            </Box>
          </div>
        )}
      </form>
    </>
  );
}
